import yaml from 'js-yaml'
import fs from 'fs'
import setting from './setting'

const config = {}
// TODO: load default config in template
try {
  if (fs.existsSync(setting.configPath)) {
    const data = fs.readFileSync(setting.configPath)
    Object.assign(config, yaml.safeLoad(data))
  }
} catch (error) {
  // ignore
}

module.exports = config
